import {useState} from "react"
import classNames from "classnames"

import { useCheckList } from "./CheckListContext"

const TextInput = ({rec, fld, label=null, unique=false, size=20}) => {
    const {uniqueLabels, setLabelsUpdated, updateRec, genID} = useCheckList()
    // data,
    const [error, setError] = useState(null)

    const changeHandler = (event) => {
        setError(null)
    }

    // const labelIsUnique = (id, value) => {
    //     if (!uniqueLabels.includes(value)) {
    //         return true
    //     }
    //     // label is still considered unique if it's owned by 'this' (id)
    //     const found = data.find(e => e.label === value)
    //     return (!!found && found.id === id) ? true : false

    // }

    const blurHandler = (event) => {
        const {id, name, defaultValue, value} = event.target
        // defaultValue is original field value (I think)
        if (defaultValue !== value) {
            console.log(`id: ${id} name: ${name} defaultValue ${defaultValue} value: ${value}`)
            console.log(uniqueLabels)
            console.log(`includes ${value}? ${uniqueLabels.includes(value)}`)
            if (unique && "label" === fld && uniqueLabels.includes(value)) {
                setError("label is not unique")
            } else {
                setError(null)
                const newRec = Object.assign({}, rec, { [fld]: value })
                console.log(newRec)
                updateRec(newRec)
                setLabelsUpdated(true)
            }
        }
    }

    const renderInput = (rec) => {
        return (
            <>
            <input
                type="text"
                id={genID(rec, fld)}
                name={fld}
                size={size}
                className={classNames({"has-error": !!error})}
                defaultValue={rec[fld]}
                onChange={changeHandler}
                onBlur={blurHandler}
            />
            {!!error && (<><br/> <span className="error-message">{error}</span></>)}
            </>
        )
    }
    // if (!label) {
    //     return renderInput(rec)
    // }
    return (
        <>
        {!!label && <label> {label}: </label>}
        {renderInput(rec)}
        </>
    )
}

export default TextInput